const UserRole = {

    // FIELDS
    "user": "المستخدم",
    "role": "الدور",
    "search": "بحث",

    // PAGE HEADER
    "user_role": "دور المستخدم",

    // ERROR
    "error_user": "يرجى تحديد المستخدم",
    "error_role": "يرجى تحديد الدور",

    // TABLE HEADER
    "table_user": 'المستخدم',
    "table_role": "الدور",

}

export default UserRole;